/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import '../styles/pagination.scss';
import { DOTS, usePagination } from '../containers/usePagination';

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const generateKey = () => {
        const randomOffset = 1000;
        return Math.random() * randomOffset + Math.random();
    };

    const lastPage = paginationRange[paginationRange.length - 1];

    return (
        <div style={{ marginTop: '2rem' }}>
            <ul
                className={`pagination-container ${className}`}
            >
                <li
                    className={`pagination-item ${currentPage === 1 ? 'disabled' : ''}`}
                    onClick={onPrevious}
                    role="presentation"
                >
                    <div className="arrow left" />
                </li>
                {paginationRange.map(pageNumber => {
                    if (pageNumber === DOTS) {
                        return <li key={generateKey()} className="pagination-item dots">&#8230;</li>;
                    }

                    return (
                        <li
                            key={generateKey()}
                            className={`pagination-item ${pageNumber === currentPage ? 'selected' : ''}`}
                            onClick={() => onPageChange(pageNumber)}
                            role="presentation"
                        >
                            {pageNumber}
                        </li>
                    );
                })}
                <li
                    className={`pagination-item ${currentPage === lastPage ? 'disabled' : ''}`}
                    onClick={onNext}
                    role="presentation"
                >
                    <div className="arrow right" />
                </li>
            </ul>
        </div>
    );
};

export default Pagination;
